import { ethers, BrowserProvider, JsonRpcSigner } from 'ethers';
import type { Account, Chain, Client, Transport } from 'viem';
import { useState, useEffect } from 'react';
import { useConnectorClient } from 'wagmi';
import { getProvider } from '../helpers/providers';

export async function clientToSigner(client: Client<Transport, Chain, Account>) {
  const { account, chain, transport } = client;
  if (!account || !account.address) {
    throw new Error('Invalid client or client account');
  }
  const network = {
    chainId: chain?.id ?? 0,
    name: chain?.name ?? 'unknown',
    ensAddress: chain?.contracts?.ensRegistry?.address ?? undefined,
  };
  const provider = transport
    ? new BrowserProvider(transport, network)
    : await getProvider();
  return new JsonRpcSigner(provider, account.address);
}

export function useEthersSigner({ chainId }: { chainId?: number } = {}) {
  const { data: client } = useConnectorClient({ chainId });
  const [signer, setSigner] = useState<JsonRpcSigner | undefined>(undefined);
  useEffect(() => {
    if (client) {
      clientToSigner(client).then(setSigner).catch(console.error);
    }
  }, [client]);
  return signer;
}
